module.exports = __webpack_public_path__ + "static/media/video_placeholder.47f1e686.svg";